/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { Component, useRef, useState, useEffect } from "react";
//import {variables} from './Variables.js'
import { loadModules } from "esri-loader";
//import { Trip } from './Trip.js'



const TransMap = (props) => {
    const mapRef = useRef();
    const [locdata, setLocdata] = useState({
        longitude: 0,
        latitude: 0,
        address:''
    })
    //const [longitude, setLongitude] = useState(0);
    //const [latitude, setLatitude] = useState(0);
    //const [address, setAddress] = useState('Address not rendered.');
    //let address = '';
    useEffect(() => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(["esri/config", "esri/rest/locator",
            "esri/Map",
            "esri/views/MapView",
            "esri/widgets/Locate",
            "esri/widgets/Track",
            "esri/Graphic",
            "esri/widgets/Compass",
            "esri/layers/GraphicsLayer",
            "esri/widgets/Sketch",
            "esri/geometry/Point",
            "esri/PopupTemplate",
            "esri/widgets/BasemapToggle"], { css: true })
            .then(([esriConfig,locator, Map, MapView, Locate, Track, Graphic, Compass, GraphicsLayer, Sketch, Point, PopupTemaplate, BasemapToggle]) => {
                
                //const locatorTask = new locator({
                //    url:
                //        "https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer"
                //});

                // Create a locator url using the world geocoding service
  const locatorUrl = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer";

                var graphicsLayer = new GraphicsLayer();
                var lat = 0;
                var lon = 0;
                var map = new Map({
                    basemap: "streets-navigation-vector",
                    layers: [graphicsLayer]
                });

                // load the map view at the ref's DOM node
                var view = new MapView({
                    container: mapRef.current,
                    map: map,
                    center: [-15.477514771635624, 15.350737443316067],
                    zoom: 10
                });

                esriConfig.apiKey = "AAPKb4d691e164ad490894c47e2ff2d533ebMhd97O-oRKGFcQdwXRMYUtl7fV7hDlCfJQGqIrzYGlUGG3-eb5yyxQIJLkrRn20R";

                //Basemap Toggle

                var basemapToggle = new BasemapToggle({
                    view: view,
                    nextBasemap: "satellite"
                });

                view.ui.add(basemapToggle, 'top-right');

                graphicsLayer.graphics.removeAll()
                view.graphics.removeAll();

                //if (props.reslong !== 0 && props.reslat !== 0) {
                //    graphicsLayer.removeAll();
                //    var pointoGo = new Point();
                //    pointoGo.longitude = props.reslong;
                //    pointoGo.latitude = props.reslat;
                //    const resloc = new Graphic({
                //        geometry: pointoGo,
                //        symbol: {
                //            type: "simple-marker",
                //            size: "15px",
                //            color: "green",
                //            outline: {
                //                color: "red",
                //                width: "2px"
                //            }
                //        }
                //    })

                //    graphicsLayer.add(resloc);
                //    let opts = {
                //        duration: 5000  // Duration of animation will be 5 seconds
                //    };

                //    // go to point at LOD 15 with custom duration
                //    view.goTo({
                //        target: pointoGo,
                //        zoom: 15
                //    }, opts);
                //}

                var locateWg = new Locate({
                    view: view,
                    useHeadingEnabled: false,
                    geoLocationOptions: {
                        geoLocationEnabled: false
                    },
                    graphic: new Graphic({
                        symbol: { type: "simple-marker" }
                    }),
                    goToOverride: function (view, options) {
                        options.target.scale = 1500;  // Override the default map scale
                        return view.goTo(options.target);
                    }
                });

                view.ui.add(locateWg, "top-left");
                //view.on("load",locateWg.locate());

                //if (props.reslong === 0 || props.reslat === 0) {
                //    //alert("Locating")
                //    view.when(() => {
                //        locateWg.locate();
                //    });
                //}

                locateWg.on("locate", function (locateEvt) {
                    //setCurrentId(0)
                    //setCovMapId(0)
                    console.log("Event Data",locateEvt);
                    lat = locateEvt.position.coords.latitude;
                    lon = locateEvt.position.coords.longitude;
                    addrloc(lon, lat)

                });

                var addrloc = ((longi, lati) => {
                    const locpoint = new Point();
                    locpoint.longitude = longi;
                    locpoint.latitude = lati;
                    //setLongitude(longi);
                    //setLatitude(lati);
                    //setAddress(prev => prev.trim());
                    graphicsLayer.removeAll();
                    const lcparams = {
                        location: locpoint, //locateEvt.target.graphic.geometry,
                    };
                    locator
                        .locationToAddress(locatorUrl,lcparams)
                        .then(function (response) {
                            //console.log(response);
                            //setAddress(response.attributes.LongLabel);
                            //setLongitude(longi);
                            //setLatitude(lati);
                            //const newadd = response.attributes.LongLabel;
                            //setAddress(newadd + 'awg');
                            //console.log(address);
                            //setAddress(newadd.replace('awg', ''));
                            //console.log(address);
                            //setAddress(prev => prev.trim());
                            setLocdata({
                                ...locdata,
                                longitude: longi,
                                latitude: lati,
                                address: response.attributes.LongLabel
                            });
                               
                           //console.log("Location:", locdata);
                            //let myaddress= response.attributes.LongLabel;
                            console.log("Response:", response.attributes.LongLabel + "/ " + longi + " : " + lati);
                            //setAddress(prev => prev.trim());
                            const myloc = new Graphic({
                                geometry: locpoint,
                                symbol: {
                                    type: "simple-marker",
                                    size: "15px",
                                    color: "green",
                                    outline: {
                                        color: "red",
                                        width: "2px"
                                    }
                                }
                            })
                            //setAddress(myaddress);
                            graphicsLayer.add(myloc);
                            //setAddress(prev => prev.trim());
                            document.getElementById("grabCoords").click();

                        })
                        .catch(function (error) {
                            window.alert("Probleme: " + error);

                        });

                });

                
                view.on("click", function (event) {
                    graphicsLayer.removeAll();
                    //setCurrentId(0);
                    //setCovMapId(0)
                    view.hitTest(event).then(function (response) {
                        //  window.alert(response.results.length)
                        if (response.results.length > 1) {
                            var graphic = response.results.filter(function (result) {
                                // check if the graphic belongs to the layer of interest
                                // window.alert(JSON.stringify(result.graphic));
                                return result.graphic.layer === graphicsLayer;
                            })[0].graphic;
                            if (graphic) {
                                window.alert(graphic.attributes.ID)
                                //setCurrentId(graphic.attributes.ID)
                                //setCovMapId(graphic.attributes.ID)
                            }

                            // console.log(graphic.attributes.ID);
                        } else {
                            //setCurrentId(0)
                            //setCovMapId(0);
                            //setLocdata({
                            //    ...locdata,
                            //    longitude: 0,
                            //    latitude: 0,
                            //    address: ''
                            //})
                            lat = event.mapPoint.latitude;
                            lon = event.mapPoint.longitude;
                            console.log("Event Data", event.mapPoint);
                            addrloc(lon, lat);
                        }
                    });



                });


                return () => {
                    if (view) {
                        // destroy the map view
                        view.container = null;
                    }
                }
            });
    }, [props.locdata,props.reslong,props.reslat,props.resaddr]);

    return (
        <div style={{ height: '200px' }} ref={mapRef}>
            <button style={{ visibility: "hidden" }} id="grabCoords" onClick={() => props.getData(locdata.longitude,locdata.latitude,locdata.address)}></button>
            <p id="reslonglat" ref={TransMap.input} style={{ visibility: "hidden", width: "0px", height: "0px" }} >{props.reslong + ";" + props.reslat + ";" + props.resaddr}</p>
        </div>

    )

}

export default TransMap;